import { default as routes } from '../components/routes'

export default [...routes]
